/*
>> Theme constant containing theme specs
*/

const currentYear = new Date().getFullYear();

export const homelinkTheme = {
  // colors
  navbarBgColor: "bg-[#1C2839]",
  navbarTextColor: "text-white",
  navbarTextHoverColor: "hover:text-[#FEA250]",
  footerBgColor: "bg-[#1A1F26]",
  footerTextColor: "text-white",
  secondaryNavMenuItemBgColor: "bg-white",
  secondaryNavActiveMenuItem: "border-4 border-[#FEA250]",
  buttonBgColor: "bg-[#265CA4]",
  buttonHoverBgColor: "hover:bg-[#265CA4]",
  redirectingTextColor: "text-white",
  redirectingBorder: "border border-b-4 border-b-[#265CA4]",
  // file paths
  logo: "https://greenmarbles-client-sites.imgix.net/homelink/marketing-site/homelink_logo_white.svg",
  footerLogo:
    "https://greenmarbles-client-sites.imgix.net/homelink/marketing-site/gentex_white.svg",
  sgIcon: "/guaranteeicon.svg",
  title: "Homelink",
  favicon: "/Homelink/favicon.png",
  copyrightText: `&copy; ${currentYear} HomeLink`,
};

let COGNITO_DOMAIN = "";
let COGNITO_REDIRECTSIGNIN = "";
let COGNITO_REDIRECTSIGNOUT = "";
let COGNITO_REDIRECT_URI = "";
let COGNITO_REGION = "";
let SHOP_URL = "";
let MARKETING_URL = "";
let ACCOUNT_URL = "";
let COOKIE_STORAGE_DOMAIN = "";
let CHECKOUT_URL = "";
let ACCOUNT_API_URL = "";
let COGNITO_APP_CLIENT_ID = "";
let COGNITO_USER_POOL_ID = "";
let CART_API_URL = "";

if (process.env.REACT_APP_MODE === "local") {
  COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
  COGNITO_REDIRECTSIGNIN = process.env.REACT_APP_COGNITO_REDIRECTSIGNIN;
  COGNITO_REDIRECTSIGNOUT = process.env.REACT_APP_COGNITO_REDIRECTSIGNOUT;
  COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI;
  COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
  SHOP_URL = process.env.REACT_APP_SHOP_URL;
  MARKETING_URL = process.env.REACT_APP_MARKETING_URL;
  ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL;
  CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;
  ACCOUNT_API_URL = process.env.REACT_APP_ACCOUNT_API_URL;
  COOKIE_STORAGE_DOMAIN = process.env.REACT_APP_COOKIE_STORAGE_DOMAIN;
  COGNITO_APP_CLIENT_ID = process.env.REACT_APP_COGNITO_APP_CLIENT_ID;
  COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
  CART_API_URL = process.env.REACT_APP_CART_API_URL;
} else if (process.env.REACT_APP_MODE === "homelink-dev") {
  COGNITO_DOMAIN = "homelink-ecommweb-430666279062.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://homelink-account2-dev.smarthome-sales.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://homelink-account2-dev.smarthome-sales.com";
  COGNITO_REDIRECT_URI = "https://homelink-account2-dev.smarthome-sales.com/redirecting";
  COGNITO_REGION = "us-east-2";
  SHOP_URL = "https://homelink-shop-dev.smarthome-sales.com";
  MARKETING_URL = "https://homelink-marketing-dev.smarthome-sales.com";
  ACCOUNT_URL = "https://homelink-account2-dev.smarthome-sales.com";
  CHECKOUT_URL = "https://homelink-cart-dev.smarthome-sales.com";
  ACCOUNT_API_URL = "https://br74gzo7ld.execute-api.us-east-2.amazonaws.com/v1";
  COOKIE_STORAGE_DOMAIN = "smarthome-sales.com";
  COGNITO_APP_CLIENT_ID = "5g2666klg81v75iur41t7iqhoj";
  COGNITO_USER_POOL_ID = "us-east-2_LmoqMa8uh";
  CART_API_URL = "https://pn1f5osh1g.execute-api.us-east-2.amazonaws.com/v1";
} else if (process.env.REACT_APP_MODE === "homelink-prod") {
  COGNITO_REGION = "us-east-2";
  COGNITO_DOMAIN = "homelink-ecommweb-832527406606.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://smarthome-account2.homelinksmarthome.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://smarthome-account2.homelinksmarthome.com";
  COGNITO_REDIRECT_URI = "https://smarthome-account2.homelinksmarthome.com/redirecting";
  SHOP_URL = "https://smarthome-shop.homelink.com";
  MARKETING_URL = "https://smarthome.homelink.com";
  ACCOUNT_URL = "https://smarthome-account2.homelinksmarthome.com";
  CHECKOUT_URL = "https://smarthome-cart2.homelinksmarthome.com";
  ACCOUNT_API_URL = "https://s0z2v7llu0.execute-api.us-east-2.amazonaws.com/v1";
  // COOKIE_STORAGE_DOMAIN = "homelink.com";
  COOKIE_STORAGE_DOMAIN = "homelinksmarthome.com";
  COGNITO_APP_CLIENT_ID = "4pbamvqhmgq9sbq6ue5qvqps80";
  COGNITO_USER_POOL_ID = "us-east-2_uCcPvy5ci";
  CART_API_URL = "https://ismvqv9q08.execute-api.us-east-2.amazonaws.com/v1";
}

export const homelinkConstants = {
  ACCOUNT_API_URL,
  COGNITO_APP_CLIENT_ID,
  COGNITO_USER_POOL_ID,
  CART_API_URL,
  COGNITO_DOMAIN: COGNITO_DOMAIN,
  COGNITO_REDIRECTSIGNIN: COGNITO_REDIRECTSIGNIN,
  COGNITO_REDIRECTSIGNOUT: COGNITO_REDIRECTSIGNOUT,
  COGNITO_REDIRECT_URI: COGNITO_REDIRECT_URI,
  COGNITO_REGION: COGNITO_REGION,
  SHOP_URL: SHOP_URL,
  MARKETING_URL: MARKETING_URL,
  ACCOUNT_URL: ACCOUNT_URL,
  CHECKOUT_URL: CHECKOUT_URL,
  PRIVACY_POLICY_URL: `https://www.gentex.com/terms-privacy`,
  TERMS_AND_CONDITIONS_URL: `https://www.gentex.com/terms-privacy`,
  COOKIE_STORAGE_DOMAIN: COOKIE_STORAGE_DOMAIN,
  COOKIE_STORAGE_PATH: "/",
  COOKIE_STORAGE_EXPIRES: 7,
  COOKIE_STORAGE_SECURE: false,
  COOKIE_MAX_AGE: 2592000,
};

export default {
  homelinkTheme,
  homelinkConstants,
};
